import { StatCard } from '@/components'
import { cariAngka } from '@/components/LaporanTampil'
import { formatRupiah } from '@/lib/format'
import { HalamanLaporan } from './HalamanLaporan'

/** Laporan Aktivitas: pendapatan - beban = surplus/defisit. */
export default function LaporanAktivitas() {
  return (
    <HalamanLaporan
      judul="Laporan Aktivitas"
      deskripsi="Pendapatan dan beban selama periode, menghasilkan surplus atau defisit."
      path="/reports/activity"
      namaEkspor="laporan-aktivitas"
      ekstraKonten={(data) => {
        const pendapatan = cariAngka(data, ['totalPendapatan', 'pendapatan', 'totalRevenue', 'revenue'])
        const beban = cariAngka(data, ['totalBeban', 'beban', 'totalExpense', 'expense'])
        const surplus = cariAngka(data, ['surplusDefisit', 'surplus', 'defisit', 'hasilUsaha', 'netIncome'])
        if (pendapatan === null && beban === null && surplus === null) return null

        const hitung = (pendapatan ?? 0) - (beban ?? 0)
        const nilaiSurplus = surplus ?? hitung

        return (
          <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
            <StatCard
              label="Total Pendapatan"
              nilai={pendapatan}
              nada="hijau"
              formatNilai={(v) => formatRupiah(Number(v ?? 0))}
            />
            <StatCard
              label="Total Beban"
              nilai={beban}
              nada="merah"
              formatNilai={(v) => formatRupiah(Number(v ?? 0))}
            />
            <StatCard
              label={nilaiSurplus >= 0 ? 'Surplus' : 'Defisit'}
              nilai={nilaiSurplus}
              nada={nilaiSurplus >= 0 ? 'hijau' : 'merah'}
              sublabel={`Pendapatan − Beban = ${formatRupiah(hitung)}`}
              formatNilai={(v) => formatRupiah(Number(v ?? 0))}
            />
          </div>
        )
      }}
    />
  )
}
